import { render, staticRenderFns } from "./Burnout.vue?vue&type=template&id=2181284c&scoped=true&"
import script from "./Burnout.vue?vue&type=script&lang=js&"
export * from "./Burnout.vue?vue&type=script&lang=js&"
import style0 from "./Burnout.vue?vue&type=style&index=0&id=2181284c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2181284c",
  null
  
)

export default component.exports